/* ================================================================
   ENNOHUB V2 — Global JavaScript
   ================================================================ */

/* ————————————————————————————————————
   Drawer / Slide-out Panel
   ———————————————————————————————————— */
class EnnoDrawer {
  constructor() {
    this.overlay = document.querySelector('.drawer-overlay');
    this.drawers = document.querySelectorAll('.drawer');
    this.init();
  }

  init() {
    // Open buttons
    document.querySelectorAll('[data-drawer-toggle]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const target = btn.getAttribute('data-drawer-toggle');
        document.querySelector('#' + target).classList.toggle('active');
        // this.open(target);
      });
    });

    // // Close buttons
    // document.querySelectorAll('[data-drawer-close]').forEach(btn => {
    //   btn.addEventListener('click', () => this.closeAll());
    // });

    // // Overlay click
    // if (this.overlay) {
    //   this.overlay.addEventListener('click', () => this.closeAll());
    // }

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeAll();
    });
  }

  // open(id) {
  //   const drawer = document.getElementById(id);
  //   if (!drawer) return;
  //   drawer.classList.add('active');
  //   if (this.overlay) this.overlay.classList.add('active');
  //   document.body.style.overflow = 'hidden';
  // }

  closeAll() {
    this.drawers.forEach(d => d.classList.remove('active'));
    if (this.overlay) this.overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
}

/* ————————————————————————————————————
   Accordion
   ———————————————————————————————————— */
class EnnoAccordion {
  constructor() {
    document.querySelectorAll('.accordion__trigger').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.accordion__item');
        const isActive = item.classList.contains('active');
        // Close siblings (optional: toggle only)
        // item.parentElement.querySelectorAll('.accordion__item').forEach(i => i.classList.remove('active'));
        item.classList.toggle('active', !isActive);
      });
    });
  }
}

/* ————————————————————————————————————
   Tabs
   ———————————————————————————————————— */
class EnnoTabs {
  constructor() {
    document.querySelectorAll('.tabs').forEach(tabGroup => {
      const buttons = tabGroup.querySelectorAll('.tabs__btn');
      const panels = tabGroup.querySelectorAll('.tabs__panel');

      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          const target = btn.getAttribute('data-tab');

          buttons.forEach(b => b.classList.remove('active'));
          panels.forEach(p => p.classList.remove('active'));

          btn.classList.add('active');
          const panel = tabGroup.querySelector(`[data-panel="${target}"]`);
          if (panel) panel.classList.add('active');
        });
      });
    });
  }
}

/* ————————————————————————————————————
   Quantity Selector
   ———————————————————————————————————— */
class EnnoQuantity {
  constructor() {
    document.querySelectorAll('.quantity-selector').forEach(selector => {
      const input = selector.querySelector('.quantity-selector__input');
      const minus = selector.querySelector('[data-qty="minus"]');
      const plus = selector.querySelector('[data-qty="plus"]');

      if (minus) minus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });

      if (plus) plus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    });
  }
}

/* ————————————————————————————————————
   Sticky Header
   ———————————————————————————————————— */
class EnnoStickyHeader {
  constructor() {
    this.header = document.querySelector('.header');
    if (!this.header) return;

    this.lastScroll = 0;
    this.headerHeight = this.header.offsetHeight;

    window.addEventListener('scroll', () => this.onScroll(), { passive: true });
  }

  onScroll() {
    const currentScroll = window.scrollY;

    if (currentScroll > this.headerHeight) {
      this.header.classList.add('header--sticky');
    } else {
      this.header.classList.remove('header--sticky');
    }

    this.lastScroll = currentScroll;
  }
}

/* ————————————————————————————————————
   Utility: Format Money
   ———————————————————————————————————— */
function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const value = (parseInt(cents) / 100).toFixed(2);
  // Basic NZD format: $X,XXX.XX
  const parts = value.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const formatted = '$' + parts.join('.');
  return formatted.replace(/\.00$/, '');
}

/* ————————————————————————————————————
   Init on DOMContentLoaded
   ———————————————————————————————————— */
/* ————————————————————————————————————
   Country Selector Dropdown
   ———————————————————————————————————— */
class EnnoCountrySelector {
  constructor() {
    this.btn = document.querySelector('[data-country-toggle]');
    this.dropdown = document.querySelector('[data-country-dropdown]');
    if (!this.btn || !this.dropdown) return;

    this.btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = !this.dropdown.hidden;
      this.dropdown.hidden = isOpen;
    });

    document.addEventListener('click', (e) => {
      if (!this.dropdown.hidden && !this.dropdown.contains(e.target) && !this.btn.contains(e.target)) {
        this.dropdown.hidden = true;
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.dropdown.hidden = true;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new EnnoDrawer();
  new EnnoAccordion();
  new EnnoTabs();
  new EnnoQuantity();
  new EnnoStickyHeader();
  new EnnoCountrySelector();
});

/* ————————————————————————————————————
   Collection Swatches
   One row of 2-4 color dots per card.
   Only runs on pages with .collection-main__grid.
   ———————————————————————————————————— */
(function() {
  function initSwatches() {
    var grid = document.querySelector('.collection-main__grid');
    if (!grid) return;
    var cards = grid.querySelectorAll('.product-card');
    if (!cards.length) return;

    /* 1. Parse each card's data from the DOM */
    var cardData = [];
    cards.forEach(function(card) {
      var link = card.querySelector('.product-card__link');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var handleMatch = href.match(/\/products\/([^?]+)/);
      if (!handleMatch) return;

      var subtitle = card.querySelector('.product-card__subtitle');
      var subtitleText = subtitle ? subtitle.textContent.trim() : '';
      var parts = subtitleText.split(' \u2013 ');
      var color = parts[0] || '';
      var style = parts[1] || '';
      var base = parts[2] || '';

      var mainImg = card.querySelector('.product-card__image--default');
      var hoverImg = card.querySelector('.product-card__image--hover');
      var imgSrc = mainImg ? mainImg.getAttribute('src') : '';
      var hoverSrc = hoverImg ? hoverImg.getAttribute('src') : '';

      var priceEl = card.querySelector('.product-card__price');
      var priceHTML = priceEl ? priceEl.innerHTML : '';

      var priceCompareAt = card.querySelector('.product-card__price-compare') ? Number(card.querySelector('.product-card__price-compare').textContent.replace(/\D/g, "")) : '';
      var priceSale = card.querySelector('.product-card__price-sale') ? Number(card.querySelector('.product-card__price-sale').textContent.replace(/\D/g, "")) : '';
      var discountPercentageEl = card.querySelector('.product-card__sale-flash > span') ? card.querySelector('.product-card__sale-flash > span') : '';

      var variantMatch = href.match(/[?&]variant=(\d+)/);
      var cardLink = link;

      cardData.push({
        card: card,
        handle: handleMatch[1],
        color: color,
        style: style,
        base: base,
        imgSrc: imgSrc,
        hoverSrc: hoverSrc,
        subtitleEl: subtitle,
        mainImgEl: mainImg,
        hoverImgEl: hoverImg,
        priceEl: priceEl,
        cardLink: cardLink,
        originalHref: href,
        originalSubtitle: subtitleText,
        originalImgSrc: imgSrc,
        originalHoverSrc: hoverSrc,
        originalPriceHTML: priceHTML,
        originalPriceCompareAt: priceCompareAt,
        originalPriceSale: priceSale,
        discountPercentageEl: discountPercentageEl
      });
    });

    /* 2. Group by handle + style */
    var groups = {};
    cardData.forEach(function(d) {
      var key = d.handle + '||' + d.style + '||' + d.base;
      if (!groups[key]) groups[key] = [];
      groups[key].push(d);
    });

    /* 3. Color name → hex */
    function colorToHex(name) {
      if (name.indexOf('Brown') >= 0) return '#7a4100';
      if (name.indexOf('Black') >= 0) return '#000000';
      return '#666666';
    }

    /* 4. Build swatches for every card in groups with 2+ colors */
    Object.keys(groups).forEach(function(key) {
      var group = groups[key];
      var seen = {};
      var uniqueColors = [];
      group.forEach(function(d) {
        if (!seen[d.color]) {
          seen[d.color] = true;
          uniqueColors.push({ color: d.color, imgSrc: d.imgSrc, hoverSrc: d.hoverSrc, href: d.originalHref, priceHTML: d.originalPriceHTML, priceCompareAt: d.originalPriceCompareAt, priceSale: d.originalPriceSale, discountPercentageEl: d.discountPercentageEl });
        }
      });
      if (uniqueColors.length < 2) return;

      group.forEach(function(d) {
        var ul = document.createElement('ul');
        ul.className = 'product-card__swatches';

        uniqueColors.forEach(function(uc) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          if (d.cardLink && uc.href) {
            a.href = uc.href;
          }
          var span = document.createElement('span');
          span.className = 'product-card__swatch';
          if (uc.color === d.color) span.className += ' product-card__swatch--selected';
          // span.style.backgroundColor = colorToHex(uc.color);
          span.title = uc.color;

          span.addEventListener('mouseover', function() {
            if (d.mainImgEl) {
              d.mainImgEl.setAttribute('src', uc.imgSrc);
              d.mainImgEl.setAttribute('srcset', uc.imgSrc);
            }
            if (d.hoverImgEl && uc.hoverSrc) {
              d.hoverImgEl.setAttribute('src', uc.hoverSrc);
            }
            if (d.subtitleEl) {
              d.subtitleEl.textContent = uc.color + (d.style ? ' \u2013 ' + d.style : '') + (d.base ? ' \u2013 ' + d.base : '');
            }
            if (d.cardLink && uc.href) {
              d.cardLink.setAttribute('href', uc.href);
            }
            if (d.priceEl && uc.priceHTML) {
              d.priceEl.innerHTML = uc.priceHTML;
            }
            if (uc.priceCompareAt > uc.priceSale) {
              d.discountPercentageEl.innerHTML = Math.round((uc.priceCompareAt - uc.priceSale) / uc.priceCompareAt * 100);
            }
            ul.querySelectorAll('.product-card__swatch').forEach(function(s) {
              s.classList.remove('product-card__swatch--selected');
            });
            span.classList.add('product-card__swatch--selected');
          });

          a.appendChild(span);
          li.appendChild(a);
          ul.appendChild(li);
        });

        // ul.addEventListener('mouseleave', function() {
        //   if (d.mainImgEl) {
        //     d.mainImgEl.setAttribute('src', d.originalImgSrc);
        //     d.mainImgEl.setAttribute('srcset', d.originalImgSrc);
        //   }
        //   if (d.subtitleEl) {
        //     d.subtitleEl.textContent = d.originalSubtitle;
        //   }
        //   ul.querySelectorAll('.product-card__swatch').forEach(function(s) {
        //     s.classList.remove('product-card__swatch--selected');
        //   });
        //   ul.querySelectorAll('.product-card__swatch').forEach(function(s) {
        //     if (s.title === d.color) s.classList.add('product-card__swatch--selected');
        //   });
        // });

        d.card.appendChild(ul);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatches);
  } else {
    initSwatches();
  }
})();
